import { FC, useState, useMemo } from 'react';
import { useStore } from 'hooks/useRootStore';
import { useAppPreloader } from 'hooks/useAppPreloader';
import { useMutation, useQuery } from 'react-query';
import { Paper } from '@material-ui/core';
import { GridColumns, GridCellParams, DataGrid } from '@material-ui/data-grid';
import { useStyles } from './styles';
import EmailIcon from '../../../assets/icons/EndUser/Email.svg';
import { getRowsPerPageOptions } from 'utils/pagination';
import { toFormatDateTime } from 'utils';
import { handleCompanyUrl } from 'utils/organizationUtils';

export const ImportTable: FC = () => {
  const {
    importTableStore: { getImportLdapLogs, importView, viewUser },
    notificationStore: { openNotification },
  } = useStore();
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const getImportReq = useQuery('getImport', () => getImportLdapLogs(), {
    onError: (error: Error) => openNotification('error', error.message),
  });

  const rows = useMemo(() => {
    return !getImportReq.isFetching ? importView : [];
  }, [importView, getImportReq.isFetching]);
  const getClickedUser = useMutation('viewUser', (ClientId: string) => viewUser(ClientId), {
    onSuccess: (user) => {
      localStorage.setItem('ClickedUser', JSON.stringify(user.data.data));
      const url = `${handleCompanyUrl('/user/view')}`;
      window.open(url, '_blank');
      setLoading(false);
    },
    onError: (error: any) => {
      setLoading(false);
      openNotification('error', error.data.message);
    },
  });

  const handleClick = (params: GridCellParams, event: any) => {
    const id = params.row.dn;
    event.stopPropagation();
    getClickedUser.mutate(id);
    setLoading(true);
  };

  const [pageSize, setPageSize] = useState(10);
  const rowsPerPageOptions = useMemo(() => getRowsPerPageOptions(rows), [rows]);
  const columns: GridColumns = [
    {
      field: 'created_at',
      headerName: 'ACCOUNT CREATED',
      flex: 1,
      valueGetter: (params) => toFormatDateTime(params.row.created_at),
    },
    { field: 'name', headerName: 'FULL NAME', flex: 1 },
    {
      field: 'mail',
      headerName: 'EMAIL',
      flex: 1,
      renderCell: (params: GridCellParams) => {
        const value = params.value as string;
        return (
          <div style={{ display: 'flex', gap: '10px' }}>
            <img src={EmailIcon} alt='' />
            {value}
          </div>
        );
      },
    },
    {
      field: 'status',
      headerName: 'ACCOUNT STATUS',
      flex: 1,
      // renderCell: (params: GridCellParams) => (
      //   <>
      //     <div style={{ color: params.row.status === 0 ? 'red' : 'green' }}>
      //       {params.value === 'both' ? <> Created </> : params.value}
      //     </div>
      // <span style={{ marginLeft: '12px' }}>Userid:</span>

      // <span onClick={(event) => handleClick(params, event)} className={classes.link} style={{ marginLeft: '2px' }}>
      //   {params.row.uid}
      // </span>
      //   </>
      // ),
      renderCell: (params: GridCellParams) => {
        const value = params.value as string;

        return (
          <>
            <div style={{ color: params.row.status === 0 ? 'red' : 'green' }}>
              {value === 'both' ? 'created and linked' : value}
            </div>
            <span style={{ marginLeft: '12px' }}>Userid:</span>
            <span
              onClick={(event) => handleClick(params, event)}
              className={classes.link}
              style={{ marginLeft: '2px' }}
            >
              {params.row.uid}
            </span>
          </>
        );
      },
    },
  ];
  useAppPreloader(getImportReq.isFetching || loading);
  return (
    <>
      <Paper className={classes.dataGrid} elevation={0}>
        <DataGrid
          className={classes.noBorder}
          autoHeight
          rows={rows}
          columns={columns}
          pageSize={pageSize}
          rowsPerPageOptions={rowsPerPageOptions}
          pagination
          onPageChange={(params) => setPageSize(params.pageSize)}
        />
      </Paper>
    </>
  );
};
